/**
 * File: pbDatepickerReformat.js
 *
 * On blur, create date from the viewValue.
 * If it's valid, format the date as a value that the datepicker
 * control expects.
 *
 * This lets us take advantage of sugarjs date string parsing, but still use the
 * datepicker control.
 */
(function(){
    angular
        .module('maApp.parse')
        .directive('pbDatepickerReformat', pbDatepickerReformat);

    pbDatepickerReformat.$inject = ['$filter'];

    function pbDatepickerReformat($filter){
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {

                var defaultDateFormat = 'MM-dd-yyyy';

                elm.on('blur', handleBlur);

                function handleBlur(event){
                    var dateFormat = attrs['datepickerPopup'] ? attrs['datepickerPopup'] : defaultDateFormat;
                    var viewDate = Date.create(ctrl.$viewValue);
                    if(ctrl.$viewValue && viewDate.isValid()){
                        var reformattedDate = $filter('date')(viewDate.toISOString(), dateFormat);
                        elm.val(reformattedDate);
                        ctrl.$setViewValue(reformattedDate, event.type);
                    }

                }

            }
        };
    }
})();